/**
 * Script: Recharge Custom
 * -----------------------------------------------------------------------------
 * - Describes the logic associated with product options
 * - Changes the active price depending on the selected option
 *
 * @namespace RechargeCustom
 */
window.addEventListener('DOMContentLoaded', () => {
  const rechargeOptions = document.querySelectorAll('[data-widget-container] input[name="selling_plan_select"]')
  const rechargeButtons = document.querySelectorAll('[data-widget-container] .rc_widget__option__selector')
  const activeOptions = document.querySelectorAll('[data-widget-container] .rc-option--active input[name="selling_plan_select"]')
  const reChargePopups = document.querySelectorAll('#PageContainer .rc-widget+.rc_popup')

  /**
   * Set the active price for the product depending on the selected option.
   * - get the formatted price from the parameter element `data-price` attribute
   * - insert it as text content for all product price elements except compared
   * (crossed out) ones
   * - invoke on initial load and when changing the option
   *
   * @param {HTMLElement} option - ReCharge selling plan input.
   */
  const setActivePrice = (option) => {
    const currentPrice = option?.dataset.price || ''
    const productPriceContainers = option?.closest('.shopify-section')?.querySelectorAll('.product__price:not(.product__price--compare) .money')

    if (!currentPrice || !productPriceContainers.length) {
      return
    }
    productPriceContainers.forEach(priceContainer => {
      priceContainer.textContent = currentPrice
    })
  }

  /**
   * Toggle the subscription details popup visibility.
   * - hide popup if current chosen option is `onetime` purchase
   * - invoke on initial load and when changing the option
   *
   * @param {HTMLElement} option - ReCharge selling plan input.
   */
  const toggleReChargePopupVisibility = (option) => {
    if (!reChargePopups.length) {
      return
    }

    reChargePopups.forEach(popup => {
      option?.value === 'onetime'
        ? popup.classList.add('hidden')
        : popup.classList.remove('hidden');
    });
  } 

  /**
   * If there are any active options on the initial page load, then set the
   * current price for the product
   */
  activeOptions?.forEach(option => {
    setActivePrice(option)
    toggleReChargePopupVisibility(option)
  })

  /**
   * Add `click` event for recharge inputs wrappers, so change listener and
   * associated logic will be triggered
   */
  rechargeButtons?.forEach(button => {
    button.addEventListener('click', (e) => {
      e.currentTarget.querySelector('input[name="selling_plan_select"]')?.click()
    })
  })

  /**
   * Change the price depending on the active option
   */
  rechargeOptions?.forEach(option => {
    option.addEventListener('change', (e) => {
      setActivePrice(option)
      toggleReChargePopupVisibility(option)
    })
  })
})




